module.exports = __webpack_public_path__ + "static/media/BackgroundUpperReports.b945d398.png";